// Worker base URL is injected by Vite via `define`.
import { appendTestModeQuery, getTestModeHeaders } from './test-mode';

export const WORKER_URL: string = __WORKER_URL__;

export async function apiJson<T>(
  path: string,
  init: Omit<RequestInit, 'body'> & { json?: unknown; body?: BodyInit } = {},
): Promise<{ status: number; data: T | null }> {
  const headers = new Headers(init.headers ?? {});
  const { json, body: rawBody, ...rest } = init;
  if (json !== undefined) {
    headers.set('content-type', 'application/json');
  }
  // PM 2026-06-10 (rotation fix): forward test-mode signal on every
  // request via BOTH a header and a `?test=1` query - belt-and-braces in
  // case CF middleware strips one. The header is preferred, but the
  // query survives header stripping by over-eager CDN rules.
  for (const [k, v] of Object.entries(getTestModeHeaders())) {
    headers.set(k, v);
  }
  const body: BodyInit | undefined =
    json !== undefined ? JSON.stringify(json) : rawBody;
  const url = `${WORKER_URL}${appendTestModeQuery(path)}`;
  const res = await fetch(url, {
    ...rest,
    headers,
    ...(body !== undefined ? { body } : {}),
  });
  let data: T | null = null;
  try {
    data = (await res.json()) as T;
  } catch {
    data = null;
  }
  return { status: res.status, data };
}
